import { useEffect } from 'react'

export function useObserver(ref, callback, ratio = 1, threshold = 1) {
  useEffect(() => {
    if (!ref?.current) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= ratio) {
          callback?.({ fromInterceptCheck: false })
        }
      },
      { threshold }
    )

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [ref, callback, ratio, threshold])
}